import script from "./MultiContactDialogHistory.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiContactDialogHistory.vue?vue&type=script&lang=ts&setup=true"

import "./MultiContactDialogHistory.vue?vue&type=style&index=0&id=08b7e674&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b7e674"]])

export default __exports__